// Copyright (c) Hamilton Manufacturing Corp.
import React, { useEffect } from 'react';
import styled from 'styled-components';
import QRCode from '../_common/api/QRCode';
import { QuestRoute } from '../_common/api/QuestRoutes';
import { UseDeviceId } from '../_common/api/usePersistedState';
import CountDown from '../_common/CountDown';
import Button from '../_common/form/Button';
import Input from '../_common/form/Input';
import { useGlobalState } from '../_common/globalState/GlobalStateProvider';
import LocationList from '../_common/LocationList';
import Modal from '../_common/Modal';
import Card from './Card';
import { HamQuest } from '../../App';
import QRModal from '../_common/QRModal';

const Col = styled.div`
    display: flex;
    flex-direction: column;
    width: 100%;
`
const Row = styled.div`
    display: flex;
    width: 100%;
    justify-content: center;
`

export const generateQR = (code, token, offline) => {
    // const body = (
    //     <Card noSlide>
    //         <QRCode data={code} />
    //         {token ? <CountDown type='bar' time={30} callback={() => Modal.Close()} /> : null}
    //         <Row>{!token ? code : null}</Row>
    //     </Card>
    // )
    Modal.Close();

    const body = (
        <Col>
            <QRCode data={code} />
            {token ? <CountDown type='bar' time={30} callback={() => QRModal.Close()} /> : null}
            <Row>{!token ? code : null}</Row>
        </Col>
    )
    QRModal.Show({
        body: body,
        type: 'success'
    })
}

const WashClub = ({ generate, ...props }) => {
    const { state: { active_user, }, getWashClub } = useGlobalState();
    const { washClub } = active_user;
    const WCActive = washClub.status.toLowerCase() === 'active' || washClub.status.toLowerCase() === 'endbillingpending';

    useEffect(() => {
        getWashClub();
        if (!generate) return;
        generateWCCode();
    }, [])

    const generateWCCode = async () => {
        HamQuest.post(QuestRoute.tempToken, { TempIdType: 'WashClub' }, {
            headers: {
                deviceId: await UseDeviceId()
            }
        })
            .then((res) => {
                if (!res.tempId) throw res.error;
                generateQR(res.tempId, true)
            })
            .catch(ex => {
                Modal.Show({
                    type: 'error',
                    title: 'Unable to Generate Token',
                    body: ex.blob.error || 'Sorry, something went wrong. Please try again.'
                })
            })
    }

    return (
        <Card title='Wash Club' icon='calendar'>
            <Input
                standalone
                label='Wash Club'
                value={washClub.name}
                disabled
            />
            <Input
                standalone
                label='Current Uses'
                value={washClub.useLimit ? `${washClub.useCount} / ${washClub.useLimit}` : 'Unlimited'}
                disabled
            />
            <Input
                standalone
                label='License Plate'
                value={washClub.appUserVehicle?.license}
                disabled
            />
            <Input
                standalone
                label='Next Billing Date'
                value={new Date(washClub.nextBillingDate).toLocaleDateString()}
                disabled
            />
            <LocationList itemLocations={washClub?.locations} />
            {WCActive && <Button onClick={generateWCCode} icon='QRcode'>Generate Club Token</Button>}
        </Card>
    )
}

export default WashClub;